import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

/**
 * Schema de validación para el formulario de login
 */
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, "El email es requerido")
    .email("Debe ser un email válido"),
  password: z
    .string()
    .min(1, "La contraseña es requerida")
    .min(6, "La contraseña debe tener al menos 6 caracteres"),
});

/**
 * Tipo inferido del schema para TypeScript
 */
export type LoginForm = z.infer<typeof loginSchema>;

/**
 * Valores por defecto del formulario
 */
export const defaultLoginValues: LoginForm = {
  email: "",
  password: "",
};

/**
 * Configuración de validación para React Hook Form
 */
export const loginResolver = {
  resolver: zodResolver(loginSchema),
  defaultValues: defaultLoginValues,
  mode: "onChange" as const,
};

